import { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { useAuthInit } from '@/features/auth/presentation/hooks/useAuthInit';

interface AppProviderProps {
  children: ReactNode;
}

/**
 * Componente interno que maneja la inicialización de autenticación
 */
function AuthInitializer({ children }: { children: ReactNode }) {
  const { isInitializing } = useAuthInit();

  // Mostrar loading mientras se inicializa la autenticación
  if (isInitializing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <QueryProvider>
      <AuthInitializer>
        {children}
      </AuthInitializer>
    </QueryProvider>
  );
}

